// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".rule-selector:not(.view) table[data-v-56c99e8f]{table-layout:auto}.rule-selector[data-v-56c99e8f] .box{display:grid;grid-template-columns:25% 25% 25% 15%;-moz-column-gap:1.75%;column-gap:1.75%;align-items:center;margin-bottom:10px}.rule-selector[data-v-56c99e8f] .box .key,.rule-selector[data-v-56c99e8f] .box .operator,.rule-selector[data-v-56c99e8f] .box .value{height:100%}", ""]);
// Exports
module.exports = exports;
